import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			projectsLocationTopColLeftCls: string;
			projectsLocationTopColRightCls: string;
		}
	},

	slug: string
}

class Location extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Projects Details Location Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsLocationTopColLeftCls || '', 'projects_location', { animCls: 'animate__fadeInRight25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsLocationTopColRightCls || '', 'projects_location', { animCls: 'animate__zoomIn', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Location;